module.exports = __webpack_public_path__ + "img/gjng2921_2.17a05dd8.svg";